<script lang="ts">
  const { size = '1em' }: { size?: string | number } = $props();
</script>
<svg width={size} height={size} 
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   stroke-width="2"
   stroke-linecap="round"
   stroke-linejoin="round"
   version="1.1"
   id="svg3"
   xmlns="http://www.w3.org/2000/svg"
>
  <line x1="3" y1="12" x2="21" y2="12" />
  <line x1="3" y1="6" x2="21" y2="6" />
  <line x1="3" y1="18" x2="21" y2="18" />
</svg>